import { render, staticRenderFns } from "./consumerData.vue?vue&type=template&id=1b5c4a2e&"
import script from "./consumerData.vue?vue&type=script&lang=js&"
export * from "./consumerData.vue?vue&type=script&lang=js&"
import style0 from "./consumerData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consumerData.vue"
export default component.exports